<template>
   <p v-if="metadataStore.attendeesCount" class="font-semibold text-big-number">{{  metadataStore.attendeesCount }}+</p>
</template>

<script setup>
import { useMetadataStore} from "../stores/metadata";
const metadataStore = useMetadataStore();
</script>
